export const confirmDonate = (paymentData) => {
  return {
    type: 'GOCHI_KID_DONATE_CONFIRM',
    paymentData
  };
};

export const saveDonateBankTransferATMData = (bankTransferATMData) => {
  return {
    type: 'GOCHI_KID_SAVE_DONATE_BANK_TRANSFER_ATM_DATA',
    bankTransferATMData
  }
}

export const clearDonate = () => {
  return {
    type: 'GOCHI_KID_DONATE_CLEAR'
  }
}

export const clearDonateBankTransferATMData = () => {
  return {
    type: 'GOCHI_KID_CLEAR_DONATE_BANK_TRANSFER_ATM_DATA',
  }
}

export const changeFlagOldDonateInfo = haveOldDonateInfo => {
  return {
    type: 'GOCHI_KID_CHANGE_FLAG_OLD_DONATE_INFO',
    haveOldDonateInfo
  }
}